import { jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { AdminBackgroundTaskStatus } from '../enums/admin-background-task-status';

@jsonObject
export class AdminBackgroundTaskStatusResponse {
  public constructor(
    private readonly data: {
      id: Guid;
      status: AdminBackgroundTaskStatus;
      progress: number;
      taskData?: Nillable<string>;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get status(): AdminBackgroundTaskStatus {
    return this.data.status;
  }

  public get progress(): number {
    return this.data.progress;
  }

  public get taskData(): Nillable<string> {
    return this.data.taskData;
  }

  public isDone(): boolean {
    return this.status === AdminBackgroundTaskStatus.Done;
  }

  public isInProgress(): boolean {
    return this.status === AdminBackgroundTaskStatus.InProgress;
  }
}
